import { render, staticRenderFns } from "./atomizingWireAdd.vue?vue&type=template&id=09b9b8f5&"
import script from "./atomizingWireAdd.vue?vue&type=script&lang=js&"
export * from "./atomizingWireAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09b9b8f5')) {
      api.createRecord('09b9b8f5', component.options)
    } else {
      api.reload('09b9b8f5', component.options)
    }
    module.hot.accept("./atomizingWireAdd.vue?vue&type=template&id=09b9b8f5&", function () {
      api.rerender('09b9b8f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/data-dictionary/atomizing-wire/atomizingWireAdd.vue"
export default component.exports